// StyleSection.jsx
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import MoodboardCanvasViewer from '@/components/MoodboardCanvasViewer';
import MaterialSelectedList from './MaterialSelectedList';

export const StyleSection = ({ projectData, onEdit, isEditable }) => {


  return (
    <Card className="mb-4">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-xl font-bold">Style & Inspiration</CardTitle>
        {isEditable && (
          <Button variant="outline" size="sm" onClick={() => onEdit("moodboard")}>
            Edit
          </Button>
        )}
      </CardHeader>
      <CardContent>
       
        <div className="space-y-4">
          <div className="space-y-2">
            <p><strong>Material Selection:</strong> {projectData?.selectedMoodboard}</p>
          </div>
          {projectData?.materials && (
            <MoodboardCanvasViewer 
              layers={projectData.materials}
            />
            
          )}
          {projectData?.materials && (
            <MaterialSelectedList materials={projectData.materials} />
          )}
        </div>
      </CardContent>
    </Card>
  );
};